/* eslint-disable */
import createIcon from '../createIcon';

const IconCheckOutlined = createIcon({
  name: 'icon-check-outlined',
  content: '<path d="M395.709 781.222l495.623-495.687 45.051 45.05L440.76 826.21z"/><path d="M169.88 465.738l315.42 315.42-45.114 45.051-315.42-315.42z"/>',
  width: 1024,
  height: 1024
});
export default IconCheckOutlined;
